// Helper murni buat nampilin rentang data panjang. Sengaja NOL IMPORT biar bisa
// dijalanin langsung pakai node.

export const DOT_MIN_ZOOM = 10;
export const DOT_CAP = 500;
export const CHART_TARGET_POINTS = 1500;

// Titik dot trail yang pantas digambar di kondisi peta sekarang. `bounds` objek
// polos, bukan L.LatLngBounds, biar bisa diuji tanpa Leaflet.
export function visibleTrailPoints(points, bounds, zoom, options = {}) {
  const minZoom = options.minZoom === undefined ? DOT_MIN_ZOOM : options.minZoom;
  const cap = options.cap === undefined ? DOT_CAP : options.cap;
  if (!Array.isArray(points) || points.length === 0) return [];
  if (!bounds || !Number.isFinite(Number(zoom)) || Number(zoom) < minZoom) return [];

  const inside = points.filter((point) => {
    const lat = point && point.latLong && point.latLong[0];
    const lng = point && point.latLong && point.latLong[1];
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
    if (lat < bounds.south || lat > bounds.north) return false;
    // Viewport yang melewati antimeridian punya west > east.
    return bounds.west <= bounds.east
      ? lng >= bounds.west && lng <= bounds.east
      : lng >= bounds.west || lng <= bounds.east;
  });

  if (inside.length <= cap) return inside;
  // Dijarangin merata, bukan dipotong: motong bikin separuh layar kosong.
  const stride = Math.ceil(inside.length / cap);
  return inside.filter((_, i) => i % stride === 0);
}

// Kerincian paling halus yang jumlah titiknya masih muat di layar. `options`
// diurut dari paling halus ke paling kasar.
export function suggestInterval(startMs, endMs, options, targetPoints = CHART_TARGET_POINTS) {
  const span = Math.floor((Number(endMs) - Number(startMs)) / 1000);
  const usable = (options || []).filter((option) => Number(option && option.seconds) > 0);
  if (!Number.isFinite(span) || span <= 0 || usable.length === 0) return null;
  const fits = usable.find((option) => span / option.seconds <= targetPoints);
  return (fits || usable[usable.length - 1]).value;
}

// Perkiraan jumlah titik yang bakal digambar, buat hint di date picker.
export function estimatePointCount(startMs, endMs, intervalSeconds) {
  const span = Math.floor((Number(endMs) - Number(startMs)) / 1000);
  const seconds = Number(intervalSeconds);
  if (!Number.isFinite(span) || span <= 0 || !(seconds > 0)) return 0;
  return Math.ceil(span / seconds);
}
